module.exports = __webpack_public_path__ + "img/luyuanCustomerT1.9813dcb2.png";